import { render, staticRenderFns } from "./CatalogoProfissionais.vue?vue&type=template&id=a0005afa&scoped=true"
import script from "./CatalogoProfissionais.vue?vue&type=script&lang=js"
export * from "./CatalogoProfissionais.vue?vue&type=script&lang=js"
import style0 from "./CatalogoProfissionais.vue?vue&type=style&index=0&id=a0005afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0005afa",
  null
  
)

export default component.exports